export class linkInBioRoutePaths {
  static ROOT = '';
  static BASE = 'link-in-bio';
  static CONFIGURE = ':section';
  static LISTINGS = 'listings';
  static STYLE = 'style';
  static LEGAL = 'legal';
  static SETTINGS = 'settings';
}

export const getLinkInBioRoute = (path?: string): string => {
  if (!path) {
    return `${linkInBioRoutePaths.BASE}`;
  }
  return `${linkInBioRoutePaths.BASE}/${path}`;
};
